<template>
  <a-drawer width="50%" :visible="visible" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ $t('合伙人申请详情') }}</b>
    </a-divider>
    <a-descriptions :column="2" bordered size="small">
      <a-descriptions-item :label="$t('姓名')">{{ form.name || '-' }}</a-descriptions-item>
      <a-descriptions-item :label="$t('电话')">{{ form.phone || '-' }}</a-descriptions-item>
      <a-descriptions-item :label="$t('微信号')">{{ form.wechat || '-' }}</a-descriptions-item>
      <a-descriptions-item :label="$t('合作意向')">{{ form.cooperationTypeName || '-' }}</a-descriptions-item>
      <a-descriptions-item :label="$t('店铺所在省份')">{{ form.shopProvince || '-' }}</a-descriptions-item>
      <a-descriptions-item :label="$t('店铺所在城市')">{{ form.shopCity || '-' }}</a-descriptions-item>
      <a-descriptions-item :label="$t('店铺所在区/县')">{{ form.shopDistrict || '-' }}</a-descriptions-item>
      <a-descriptions-item :label="$t('店铺详细地址')">{{ form.shopAddress || '-' }}</a-descriptions-item>
      <a-descriptions-item :label="$t('经度')">{{ form.longitude || '-' }}</a-descriptions-item>
      <a-descriptions-item :label="$t('纬度')">{{ form.latitude || '-' }}</a-descriptions-item>
<!--      <a-descriptions-item :label="$t('昵称')">{{ form.nickName || '-' }}</a-descriptions-item>-->
<!--      <a-descriptions-item :label="$t('手机号')">{{ form.mobile || '-' }}</a-descriptions-item>-->
      <a-descriptions-item :label="'审核状态'">{{ form.auditStatusName || '-' }}</a-descriptions-item>
      <a-descriptions-item :label="$t('审核人')">{{ form.auditName || '-' }}</a-descriptions-item>
      <a-descriptions-item :label="$t('审核时间')" :span="2">
        {{ form.auditTime ? parseTime(form.auditTime) : '-' }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('拒绝原因')" :span="2">
        {{ form.auditRemark || '-' }}
      </a-descriptions-item>
      <a-descriptions-item :label="$t('创建时间')" :span="2">
        {{ form.createTime ? parseTime(form.createTime) : '-' }}
      </a-descriptions-item>
    </a-descriptions>
  </a-drawer>
</template>

<script>
import { getPartnerDetail } from '@/api/partner/partner'

export default {
  name: 'PartnerDetailForm',
  data () {
    return {
      visible: false,
      form: {}
    }
  },
  methods: {
    open (row) {
      getPartnerDetail({ id: row.id }).then(response => {
        this.form = response.data
        this.visible = true
      })
    },
    onClose () {
      this.visible = false
    }
  }
}
</script>
